import {createStore} from 'vuex'
import repository from "@/api-services/repository";

export default createStore({
    state: {},
    getters: {},
    mutations: {},
    actions: {},
    modules: {
        auth: {
            state: {
                user: sessionStorage.user ? JSON.parse(sessionStorage.getItem('user')) : null,
                permissions: sessionStorage.user ? (JSON.parse(sessionStorage.getItem('user'))['data']['permissions']?.map(function (value, label) {
                    return value.name;
                })) : null,

                roles: sessionStorage.user ? (JSON.parse(sessionStorage.getItem('user'))['data']['role']?.map(function (value, label) {
                    return value;
                })) : null,
                isLoading: false
            },

            getters: {
                user: state => state.user,
                permissions: state => state.permissions,
                roles: state => state.roles,
                isLoading: state => state.isLoading,
                authenticated: state => state.user !== null,
            },

            mutations: {
                SET_USER(state, user) {
                    state.user = user;
                },
                SET_PERMISSION(state, permissions) {
                    state.permissions = permissions;
                },
                SET_ROLE(state, roles) {
                    state.roles = roles;
                },
                SET_IS_LOADING(state, flagState) {
                    state.isLoading = flagState;
                }
            },

            actions: {
                async login({commit}, user) {
                    await repository.createSession();
                    const {data} = await repository.login(user);

                      sessionStorage.user = await JSON.stringify(data);

                    await commit('SET_USER', data);
                    await commit('SET_PERMISSION', data?.data?.permissions.map(function (value, label) {
                        return value.name;
                    }));
                },

                async logout({commit}) {
                    await repository.logout();
                    await commit('SET_USER', null);
                    await commit('SET_PERMISSION', null);

                    await sessionStorage.removeItem('user');
                },

                async setIsLoading({commit}, flagState) {
                    await commit('SET_IS_LOADING', flagState);
                },
                async setUser({commit}, flagState) {
                    await commit('SET_USER', flagState);
                },

            }
        },
        settings: {
            state: {
                isLightMood: false,
                btnHeaderShow: false,
                editFlag: false,
                successModal: false,
                errorModal: false,
                successMessage: '',
                errorMessage: '',
                setDataFlag: false,
                setAnswersFlag: false,
                confirmModal: false,
                confirmMessage: '',
                activeTap: '',
                currentRoute: '',
            },

            getters: {
                isLightMood: state => state.isLightMood,
                btnHeaderShow: state => state.btnHeaderShow,
                editFlag: state => state.editFlag,
                successModal: state => state.successModal,
                errorModal: state => state.errorModal,
                successMessage: state => state.successMessage,
                errorMessage: state => state.errorMessage,
                setDataFlag: state => state.setDataFlag,
                setAnswersFlag: state => state.setAnswersFlag,
                confirmModal: state => state.confirmModal,
                confirmMessage: state => state.errorMessage,
                activeTap: state => state.activeTap,
                currentRoute: state => state.currentRoute,
            },

            mutations: {
                SET_IS_LIGHT_MOOD(state, flagState) {
                    state.isLightMood = flagState;
                },
                SET_BTN_HEADER_SHOW(state, flagState) {
                    state.btnHeaderShow = flagState;
                },
                SET_EDIT_FLAG(state, flagState) {
                    state.editFlag = flagState;
                },
                SET_SUCCESS_MODAL(state, flagState) {
                    state.successModal = flagState;
                },
                SET_ERROR_MODAL(state, flagState) {
                    state.errorModal = flagState;
                },
                SET_SUCCESS_MESSAGE(state, message) {
                    state.successMessage = message;
                },
                SET_ERROR_MESSAGE(state, message) {
                    state.errorMessage = message;
                },
                SET_DATA_FLAG(state, flagState) {
                    state.setDataFlag = flagState;
                },
                SET_ANSWERS_FLAG(state, flagState) {
                    state.setAnswersFlag = flagState;
                },

                SET_CONFIRM_MODAL(state, flagState) {
                    state.confirmModal = flagState;
                },
                SET_CONFIRM_MESSAGE(state, message) {
                    state.confirmMessage = message;
                },
                SET_ACTIVE_TAP(state, message) {
                    state.activeTap = message;
                },
                SET_CURRENT_ROUTE(state, message) {
                    state.currentRoute = message;
                },

            },

            actions: {
                async setIsLightMood({commit}, flagState) {
                    await commit('SET_IS_LIGHT_MOOD', flagState);
                },

                async setBtnHeader({commit}, flagState) {
                    await commit('SET_BTN_HEADER_SHOW', flagState);
                },

                async setEditFlag({commit}, flagState) {
                    await commit('SET_EDIT_FLAG', flagState);
                },
                async setSuccessModal({commit}, flagState) {
                    await commit('SET_SUCCESS_MODAL', flagState);
                },
                async setErrorModal({commit}, flagState) {
                    await commit('SET_ERROR_MODAL', flagState);
                },
                async setSueccessMessage({commit}, message) {
                    await commit('SET_SUCCESS_MESSAGE', message);
                },
                async setErrorMessage({commit}, message) {
                    await commit('SET_ERROR_MESSAGE', message);
                },
                async setDataFlag({commit}, flagState) {
                    await commit('SET_DATA_FLAG', flagState);
                },

                async setAnswersFlag({commit}, flagState) {
                    await commit('SET_ANSWERS_FLAG', flagState);
                },
                async setConfirmModal({commit}, flagState) {
                    await commit('SET_CONFIRM_MODAL', flagState);
                },
                async setConfirmMessage({commit}, message) {
                    await commit('SET_CONFIRM_MESSAGE', message);
                },
                async activeTap({commit}, message) {
                    await commit('SET_ACTIVE_TAP', message);
                },
                async currentRoute({commit}, message) {
                    await commit('SET_CURRENT_ROUTE', message);
                }
            }
        },
    }
})
